import React from 'react';
import PropTypes from 'prop-types';

import MuiLink from '@material-ui/core/Link';

import { useLinkStyles } from './styles';

const Link = ({ children, ...rest }) => {
	const linkClasses = useLinkStyles(rest);

	return (
		<MuiLink
			variant={rest.variant || 'body1'}
			rel={rest.target === '_blank' ? 'noopener' : ''}
			{...rest}
			classes={linkClasses}>
			{children}
		</MuiLink>
	);
};

Link.propTypes = {
	children: PropTypes.node.isRequired
};

export default Link;
